import { Component, OnInit, OnDestroy } from "@angular/core";
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    NavigationEnd,
    Router,
} from "@angular/router";
import { Observable, Subject } from "rxjs";
import { filter, map, shareReplay, startWith, takeUntil } from "rxjs/operators";
import { UserService } from "@/_services";
import { AssessmentService } from "@/_services";
import { OnboardingStateService } from "@/_services/onboarding-state.service";
import { OnboardingStatus } from "@/_models/onboarding-status.interface";

@Component({
    selector: "app-pages",
    templateUrl: "./pages.component.html",
    styleUrls: ["./pages.component.scss"],
})
export class PagesComponent implements OnInit, OnDestroy {
    hideMenu$: Observable<{
        hideDesktopMenu: boolean;
        hideMobileMenu: boolean;
    }>;

    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        private assessmentService: AssessmentService,
        private onboardingState: OnboardingStateService,
    ) {}

    ngOnInit() {
        this.hideMenu$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            startWith(this.router),
            map(() =>
                this.childrenCheck(this.activatedRoute.snapshot.firstChild),
            ),
            shareReplay(),
        );

        this.loadOnboardingStatus();
    }

    childrenCheck(snapshot: ActivatedRouteSnapshot): {
        hideDesktopMenu: boolean;
        hideMobileMenu: boolean;
    } {
        if (
            snapshot.data.hasOwnProperty("hideDesktopMenu") ||
            snapshot.data.hasOwnProperty("hideMobileMenu")
        ) {
            return {
                hideDesktopMenu: snapshot.data["hideDesktopMenu"] || false,
                hideMobileMenu: snapshot.data["hideMobileMenu"] || false,
            };
        }

        if (snapshot.children.length) {
            return this.childrenCheck(snapshot.firstChild);
        }

        return { hideDesktopMenu: false, hideMobileMenu: false };
    }

    private loadOnboardingStatus() {
        this.assessmentService
            .listAssessments()
            .pipe(
                map((assessments) =>
                    assessments.find(
                        (assessment) => assessment.title === "ASAP Form",
                    ),
                ),
                takeUntil(this.destroy$),
            )
            .subscribe((asapForm) => {
                if (asapForm) {
                    this.onboardingState.setAsapFormId(asapForm._id);
                    this.userService
                        .getOnboardingStatus(asapForm._id)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe((status) => {
                            this.onboardingState.setOnboardingStatus(status);
                        });
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
